import { render, staticRenderFns } from "./ProductsSale.vue?vue&type=template&id=7fa879ca&scoped=true&"
import script from "./ProductsSale.vue?vue&type=script&lang=js&"
export * from "./ProductsSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSale.vue?vue&type=style&index=0&id=7fa879ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa879ca",
  null
  
)

export default component.exports